import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { WithoutThemeRouteList, FrontRouteList, AdminRoutes, DriverRoutes, CustomerRoutes } from "./index";
import AdminLayout from "../layouts/AdminLayout";
import DriverLayout from "../layouts/DriverLayout";
import CustomerLayout from "../layouts/CustomerLayout";
import Home from "../frontend/pages/home/Home";

const MainRoutes = () => {

  return (<Router>
    <Routes>
      {WithoutThemeRouteList?.map(({ component: Component, path }, index) => {
        return (<Route key={index} path={path} exact element={<Component />} />);
      })}

      {FrontRouteList?.map(({ component: Component, path }, index) => {
        return (<Route key={index} path={path} exact element={<Component />} />);
      })}

      {DriverRoutes?.routeList?.map(({ component: Component, path }, index) => {
        return (<Route key={index} path={`/driver${path}`} exact element={<DriverLayout><Component /></DriverLayout>} />);
      })}

      {CustomerRoutes?.routeList?.map(({ component: Component, path }, index) => {
        return (<Route key={index} path={`/customer${path}`} exact element={<CustomerLayout><Component userScope={"Customer"} /></CustomerLayout>} />);
      })}

      {AdminRoutes?.routeList?.map(({ component: Component, path, menuName, permission }, index) => {
        return (<Route key={index} path={`${path}`} exact element={<AdminLayout><Component menuName={menuName} userScope={"Admin"} permission={permission} /></AdminLayout>} />);
      })}

      <Route path="*" element={<Home />} />
    </Routes>
  </Router>);
}

export default MainRoutes;